const LEIGHTON =
  'For almost 50 years Leighton Asia, one of the region’s largest and most respected construction companies, has been progressively building for a better future by leveraging international expertise with local intelligence. In that time Leighton has delivered some of Asia’s prestigious buildings and transformational infrastructure projects.'

/** Content for the service-details page. */
export const SERVICE_DETAIL = {
  image: '/assets/img/service-details-1.jpg',
  title: 'Development Programs',
  intro: [
    'BaseCreate is pleased to announce that it has been commissioned by Leighton Asia reposition its brand. We will help Leighton Asia evolve its brand strategy, For almost 50 years Leighton Asia, one of the region’s largest and most respected construction companies, has been progressively building for a better future by',
    LEIGHTON,
  ],
  firstBlock: { title: 'Remarking Services', body: LEIGHTON },
  videoCover: '/assets/img/service-details-video-cover.jpg',
  videoUrl: 'https://youtu.be/C2FFe5FiAqc?si=8p0Skg8lyxgHQCpg',
  afterVideo:
    'Leighton Asia’s brand refreshment will help position the company to meet the challenges of future, as it seeks to lead the industry in technological innovation and sustainable building practices to deliver long-lasting value for its clients.Leighton Asia’s brand refreshment will help position the company meet the challenges of future, as it seeks to lead the industry in technological innovation and sustainable building practices to deliver long-lasting value for its clients.',
  secondBlock: {
    title: 'Services All Details',
    body: 'Cast obscure badger jeep quail congenialy when changed as cat jeepers affectionate thus facilisi goodness this far like ipsum dolor sit amet, consectetur adipisicing elits eiusmod tempo incididunt et laboret dolore magna aliqua enim ad minim. Eveniet in vulputate esse molestie consequat, illum Eveniet in vulputate esse molestie dolore .',
    list: [
      'Creating and editing content',
      'Workflows, reporting, and content organization',
      'User & role-based administration and security',
      'Flexibility, scalability, and performance and analysis',
      'Multilingual content capabilities',
    ],
  },
} as const
